import { type NexusApiActionDef } from "./action-def.types";
import { arr, num, obj } from "./output-format.builders";

const EXECUTION_STATUS_OPTIONS = {
  allowedValues: ["", "PENDING", "RUNNING", "FAILED", "COMPLETED", "CANCELLED"],
  allowedOptions: [
    { label: "All", value: "" },
    { label: "Pending", value: "PENDING" },
    { label: "Running", value: "RUNNING" },
    { label: "Failed", value: "FAILED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Cancelled", value: "CANCELLED" }
  ]
};

const executionSummaryOutput = obj("Result", {
  executions: arr("List of executions"),
  total: num("Total matching executions"),
  limit: num("Page size applied"),
  offset: num("Offset applied")
});

export const executionActions: NexusApiActionDef[] = [
  {
    action: "executions.list",
    label: "List Executions",
    description:
      "List real workflow executions (top-level production runs), optionally filtered by workflow and status. Returns id, workflowId, status, startedAt, completedAt, and input.",
    inputSchema: {
      workflowId: { type: "string", description: "Filter by workflow ID (optional)" },
      status: {
        type: "string",
        description: "Filter by execution status (optional)",
        constraints: EXECUTION_STATUS_OPTIONS
      },
      includeTestRuns: {
        type: "boolean",
        description: "Include single-node canvas test runs (optional, default false)"
      },
      limit: { type: "number", description: "Max results (optional, default 50, max 100)" },
      offset: { type: "number", description: "Number of results to skip (optional, default 0)" }
    },
    outputFormat: executionSummaryOutput
  },
  {
    action: "executions.get",
    label: "Get Execution",
    description: "Get full details of a single workflow execution by ID",
    inputSchema: {
      executionId: { type: "string", description: "Execution ID" }
    },
    outputFormat: obj("Execution details")
  },
  {
    action: "executions.filterByInput",
    label: "Filter Executions by Input",
    description:
      "Find real executions of a workflow whose stored input has a top-level field matching a value (e.g. input.conversation_id === <X>). Excludes canvas test runs by default — ideal for deduping.",
    inputSchema: {
      workflowId: { type: "string", description: "Workflow ID" },
      inputField: {
        type: "string",
        description: "Top-level input field name (e.g. conversation_id)"
      },
      inputValue: { type: "string", description: "Value the input field must equal" },
      status: {
        type: "string",
        description: "Filter by execution status (optional)",
        constraints: EXECUTION_STATUS_OPTIONS
      },
      includeTestRuns: {
        type: "boolean",
        description: "Include single-node canvas test runs (optional, default false)"
      },
      limit: { type: "number", description: "Max results (optional, default 50, max 100)" },
      offset: { type: "number", description: "Number of results to skip (optional, default 0)" }
    },
    outputFormat: executionSummaryOutput
  }
];
